import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { LOGIN_ADMIN_USER, LOGOUT_ADMIN_USER, GET_ADMIN_USER_CURRENT_USER, UPDATE_ADMIN_USER_CURRENT_USER, POST_ADMIN_INTERNAL_USER_LOGIN } from "./actionTypes";
import { loginAdminUserSuccess, logoutAdminUserSuccess, apiError, getAdminUserCurrentUserSuccess, getAdminUserCurrentUserError, updateAdminUserCurrentUserError, updateAdminUserCurrentUserSuccess, postAdminInternalUserLoginSuccess} from "./actions"

import { AppConfiguration } from "config"
import jwt_decode from "jwt-decode";

//Include Both Helper File with needed methods
import { getCurrentUser, postJwtAdminLogin, genericPutRequest, genericDeleteRequest } from "helpers/sf_backend_helper"
import { bsh_clearAdminUserDetails, bsh_clearInsuranceIoUserDetails, bsh_getAdminUserDetails, bsh_getBothPrevAndCurrentAdminUserDetails, bsh_setAdminUserDetails, bsh_setCurrentToPrevAdminUserDetails } from "helpers/sf_browser_storage_helper";
import { OTP_STRINGS } from "helpers/sf_constants";
import { postAdminUserLogin } from "store/admin/user-login/actions";


function* loginAdminUser({ payload: { user, history } }) {
  const baseUrl = window.location.href
  const parsedUrl = new URL(baseUrl);
  //getting the part of url after the '?'
  let urlFiltersStr = parsedUrl.search.substring(1);
  if (urlFiltersStr.includes('url_filters=')) {
    urlFiltersStr = urlFiltersStr.split('url_filters=')[1]
  }
  const params = new URLSearchParams(urlFiltersStr);
  const accountId = params.get('account_id');

  try {
    const response = yield call(
      postJwtAdminLogin,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_login`,
      user
    )

    bsh_setAdminUserDetails({ token: response.data.token })
    if (user.remember_me === false) {
      window.onbeforeunload = function () {
        //localStorage.clear(); TODO: Fix issue where it gets logged out in the same browser session
      }
    }
    yield put(loginAdminUserSuccess(response.data))
    //if url is of client side then login into the client first and then redirect to that page
    if (urlFiltersStr.includes('filters') && accountId) {
      yield put(postAdminUserLogin({ user: { account: accountId }}, urlFiltersStr));
    }
    //if url is of admin side then and admin user logged in just now then redirect to that page
    if (urlFiltersStr?.includes('filters') && urlFiltersStr?.includes('admin_user=true') && !accountId) {
      history.push(urlFiltersStr)
    } else {
      history.push("/dashboard")
    }
  } catch (error) {
    if(error === OTP_STRINGS.authenticator_message || error === OTP_STRINGS.email_message){
      if (urlFiltersStr?.includes('filters') && urlFiltersStr?.includes('admin_user=true')) {
        history.push(`/login?email=${user?.admin_user?.email}&showOtp="true"&url_filters=${urlFiltersStr}`)
      } else {
        history.push(`/login?email=${user?.admin_user?.email}&showOtp="true"`)
      }
    }
    yield put(apiError(error))
  }
}

function* logoutAdminUser({ payload: { history } }) {
  try {
    let token = bsh_getAdminUserDetails().token;
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_logout`,
      {
        headers: {
          Authorization: token,
        }
      }
    )
    bsh_clearAdminUserDetails();
    bsh_clearInsuranceIoUserDetails();
    yield put(logoutAdminUserSuccess())
    history.push("/login")
    window.location.reload();
  } catch (error) {
    yield put(apiError(error))
  }
}

function* onGetCurrentUser({ payload: {history} }) {
  try {
    let token = bsh_getAdminUserDetails().token;
    let decodedToken = jwt_decode(token.split(" ")[1]);

    const response = yield call(
      getCurrentUser,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_users/profiles/${decodedToken.sub}`,
      {
        token: token
      }
    )
    yield put(getAdminUserCurrentUserSuccess(response))
  } catch (error) {
    yield put(getAdminUserCurrentUserError(error))
    bsh_clearAdminUserDetails();
    bsh_clearInsuranceIoUserDetails();
  }
}


function* onUpdateCurrentUser(action) {
  try {
    let adminUserInfo = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_signup`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: adminUserInfo.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateAdminUserCurrentUserSuccess(response))
  } catch (error) {
    yield put(updateAdminUserCurrentUserError(error))
  }
}

function* onAdminInternalUserLogin({ payload: { admin_user, history } }) {
  try {
    const both_user_token = bsh_getBothPrevAndCurrentAdminUserDetails();
    let adminUserInfo = (both_user_token?.current_token && both_user_token?.prev_token) ? ({token: both_user_token.prev_token }) : bsh_getAdminUserDetails();

    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_login`;
    const payload = { ...admin_user, token: adminUserInfo.token }
    const response = yield call(postJwtAdminLogin, URL, payload)

    bsh_setCurrentToPrevAdminUserDetails(adminUserInfo.token, response.data.token)
    yield put(postAdminInternalUserLoginSuccess(response.data));
  } catch (error) {
    if(error === OTP_STRINGS.authenticator_message || error === OTP_STRINGS.email_message){
      history.push(`/login?showOtp="true"`)
    }
    yield put(apiError(error))
  }
}

function* AdminUserLoginSaga() {
  yield takeEvery(LOGIN_ADMIN_USER, loginAdminUser)
  yield takeEvery(LOGOUT_ADMIN_USER, logoutAdminUser)
  yield takeEvery(GET_ADMIN_USER_CURRENT_USER, onGetCurrentUser)
  yield takeEvery(UPDATE_ADMIN_USER_CURRENT_USER, onUpdateCurrentUser)
  yield takeEvery(POST_ADMIN_INTERNAL_USER_LOGIN, onAdminInternalUserLogin)
}

export default AdminUserLoginSaga
